import React from "react";

const IconProspects = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 92 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M79 28C79 35.1797 73.1797 41 66 41C58.8203 41 53 35.1797 53 28C53 20.8203 58.8203 15 66 15C73.1797 15 79 20.8203 79 28Z"
        fill="#fcfbff"
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M64.5 82.5001C57.3 82.5001 46.8333 79.5001 42.5 78.0001C42.5 73.8334 43.1 64.2 45.5 59C48.5 52.5 57 49.5001 65.5 49.0001C74 48.5001 80.5 54.5001 85 57.5001C88.6 59.9001 89.8333 72.1668 90 78.0001C84.5 79.5001 71.7 82.5001 64.5 82.5001Z"
        fill="#fcfbff"
        className="fill-secondary-on-hover-target"
      />
      <path d="M48.6992 54.9C46.8992 43.4 36.7992 34.6 24.6992 34.9C11.7992 35.2 1.69922 46.2 1.69922 59.1V64.4C9.29922 66.8 17.3992 68 25.6992 68C33.9992 68 38.8 69.3 44.5 68C44.5 67.7 43.5992 65.4 43.5992 65.1C43.5992 60.9 45.5992 57.2 48.6992 54.9Z" />
      <path d="M43.6 64.2995C30.4 67.2995 16.3 66.9994 3.3 63.0994V58.9995C3.3 46.8995 12.9 36.7995 24.7 36.4995C30.7 36.2995 36.3 38.5995 40.6 42.6995C44.3 46.2995 46.6 50.9994 47.1 56.0994C48 55.1994 49 54.3995 50.1 53.7995C49.1 48.4995 46.5 43.5995 42.6 39.8995C37.7 35.2995 31.4 32.8995 24.6 33.0995C11.1 33.5995 0 45.1994 0 59.0994V65.6994L1.2 66.0995C9.1 68.5995 17.4 69.7995 25.7 69.7995C31.8 69.7995 37.9 69.0995 43.8 67.7995C43.6 66.9995 43.5 66.0994 43.5 65.1994C43.5 64.2994 43.5 64.6995 43.5 64.3995L43.6 64.2995Z" />
      <path d="M25.2992 28.2C17.4992 28.2 11.1992 21.9 11.1992 14.1C11.1992 6.3 17.4992 0 25.2992 0C33.0992 0 39.3992 6.3 39.3992 14.1C39.3992 21.9 33.0992 28.2 25.2992 28.2Z" />
      <path
        d="M84.2 53.7C79.1 48.8 72.5 46.2 65.4 46.4C51.5 46.8 40.2 58.6 40.2 72.8V79.8L41.8 80.3C49.8 82.8 58.1 84 66.5 84C74.6 84 82.6 82.8 90.4 80.5L92 80V72.3C92 65.3 89.2 58.7 84.2 53.8V53.7ZM87.5 76.6C73.5 80.5 58.4 80.4 44.6 76.4V72.7C44.6 71.9 44.6 71.2 44.7 70.5C43.9 68.9 43.5 67.1 43.5 65.1C43.5 58 49.2 52.3 56.3 52.3C55 53.5 57.4 52.3 57.9 52.4C60.2 51.4 62.8 50.8 65.4 50.7C71.2 50.6 76.8 52.7 80.9 56.8C85.1 60.9 87.4 66.3 87.4 72.1V76.5L87.5 76.6Z"
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M58 52.4C57.5 52.4 56.9 52.3 56.4 52.3C49 51 43.5992 58 43.5992 65.1C43.5992 72.2 43.8789 68.9594 44.6789 70.6594C45.4789 62.5594 50.9 55.5 58 52.4Z"
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M66.1 42.4C58 42.4 51.4 35.8 51.4 27.8C51.4 19.8 58 13.2 66.1 13.2C74.2 13.2 80.8 19.8 80.8 27.8C80.8 35.8 74.2 42.4 66.1 42.4ZM66.1 17.6C60.5 17.6 55.9 22.2 55.9 27.8C55.9 33.4 60.5 38 66.1 38C71.7 38 76.3 33.4 76.3 27.8C76.3 22.2 71.7 17.6 66.1 17.6Z"
        className="fill-secondary-on-hover-target"
      />
    </svg>
  );
};

export default IconProspects;
